export default ({ request }) => ({
  fabricExpenseItemListApi(data = {}) {
    return request({
      url: '/financial/fabric/expense/item/list',
      method: 'POST',
      data,
    })
  },
})
